<div class="bg-workspace min-vh-100">
  <top-bar [title]="'News'"></top-bar>
  <div class="container py-4 px-md-5">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a routerLink="/admin/news">News</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{ pageTitle }}</li>
      </ol>
    </nav>

    <div class="row mb-4">
      <div class="col-auto mb-3 mb-sm-0">
        <h4 class="mb-0">{{ pageTitle }}</h4>
        <small class="text-muted">Draft the content, choose the audience and set the publication date.</small>
      </div>
    </div>

    <div class="row g-4 align-items-start">
      <div class="col-12">
        <form class="card" #newsForm="ngForm">
          <div class="card-body p-4">
            <div class="row g-3">
              <div class="col-12">
                <div class="form-floating">
                  <input
                    class="form-control"
                    name="title"
                    [(ngModel)]="form.title"
                    #titleModel="ngModel"
                    [class.is-invalid]="titleModel.invalid && titleModel.touched"
                    placeholder="Title"
                    required
                  />
                  <label class="field-required">Title</label>
                  <div class="invalid-feedback">Title is required</div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-floating">
                  <input class="form-control" name="subtitle" [(ngModel)]="form.subtitle" placeholder="Subtitle" />
                  <label>Subtitle</label>
                </div>
              </div>

              <div class="col-12">
                <label class="form-label fw-semibold mb-2 field-required">Body</label>
                <div class="copy-toolbar mb-2 d-flex flex-wrap gap-2">
                  <div class="btn-group">
                    <button
                      class="btn btn-outline-secondary-2 btn-sm dropdown-toggle"
                      type="button"
                      id="copyStyleDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Style
                    </button>
                    <div class="dropdown-menu p-2 rounded-3" aria-labelledby="copyStyleDropdown">
                      <a class="dropdown-item px-3 py-2 rounded-3 cursor-pointer" (click)="applyWrap('<span>', '</span>')">Normal text</a>
                      <a class="dropdown-item px-3 py-2 rounded-3 cursor-pointer" (click)="applyParagraph()">Paragraph</a>
                      <a class="dropdown-item px-3 py-2 rounded-3 cursor-pointer lead" (click)="applyWrap('<p class=&quot;lead&quot;>', '</p>')">Lead</a>
                      <a class="dropdown-item px-3 py-2 rounded-3 cursor-pointer small" (click)="applyWrap('<small>', '</small>')">Small text</a>
                      <a class="dropdown-item px-3 py-2 rounded-3 cursor-pointer h1 mb-0" (click)="applyHeading(1)">Heading 1</a>
                      <a class="dropdown-item px-3 py-2 rounded-3 cursor-pointer h2 mb-0" (click)="applyHeading(2)">Heading 2</a>
                      <a class="dropdown-item px-3 py-2 rounded-3 cursor-pointer h3 mb-0" (click)="applyHeading(3)">Heading 3</a>
                      <a class="dropdown-item px-3 py-2 rounded-3 cursor-pointer h4 mb-0" (click)="applyHeading(4)">Heading 4</a>
                      <a class="dropdown-item px-3 py-2 rounded-3 cursor-pointer h5 mb-0" (click)="applyHeading(5)">Heading 5</a>
                      <a class="dropdown-item px-3 py-2 rounded-3 cursor-pointer h6 mb-0" (click)="applyHeading(6)">Heading 6</a>
                    </div>
                  </div>
                  <button
                    class="btn btn-outline-secondary-2 btn-sm fw-bold"
                    type="button"
                    title="Bold"
                    data-bs-toggle="tooltip"
                    (click)="applyTextStyle('fw-bold')"
                  >B</button>
                  <button
                    class="btn btn-outline-secondary-2 btn-sm fst-italic"
                    type="button"
                    title="Italic"
                    data-bs-toggle="tooltip"
                    (click)="applyTextStyle('fst-italic')"
                  >I</button>
                  <button
                    class="btn btn-outline-secondary-2 btn-sm text-decoration-underline"
                    type="button"
                    title="Underline"
                    data-bs-toggle="tooltip"
                    (click)="applyTextStyle('text-decoration-underline')"
                  >U</button>
                  <div class="btn-group">
                    <button
                      class="btn btn-outline-secondary-2 btn-sm dropdown-toggle"
                      type="button"
                      id="copyColorDropdown"
                      title="Text colour"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span class="d-inline-flex flex-column align-items-center lh-1">
                        A
                        <i class="copy-color-bar rounded-1" [ngClass]="lastCopyColorClass"></i>
                      </span>
                    </button>
                    <div class="dropdown-menu p-2 rounded-3" aria-labelledby="copyColorDropdown">
                      <a
                        *ngFor="let color of copyColors"
                        class="dropdown-item px-3 py-2 rounded-3 cursor-pointer d-flex align-items-center gap-2"
                        [title]="'Text colour: ' + color.label"
                        (click)="applyColor(color)"
                      >
                        <i class="copy-color-swatch rounded-1" [ngClass]="color.cssClass"></i>
                        {{ color.label }}
                      </a>
                    </div>
                  </div>
                  <button
                    class="btn btn-outline-secondary-2 btn-sm"
                    type="button"
                    title="Link"
                    data-bs-toggle="tooltip"
                    (click)="applyLink()"
                  >
                    <app-icon name="link"></app-icon>
                  </button>
                  <button
                    class="btn btn-outline-secondary-2 btn-sm"
                    type="button"
                    title="Bullet list"
                    data-bs-toggle="tooltip"
                    (click)="applyBulletList()"
                  >
                    <app-icon name="list"></app-icon>
                  </button>
                  <button
                    class="btn btn-outline-secondary-2 btn-sm"
                    type="button"
                    title="Numbered list"
                    data-bs-toggle="tooltip"
                    (click)="applyNumberedList()"
                  >
                    <app-icon name="list-numbered"></app-icon>
                  </button>
                  <div class="btn-group">
                    <button
                      class="btn btn-outline-secondary-2 btn-sm dropdown-toggle"
                      type="button"
                      id="copyAlignDropdown"
                      title="Align text"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <app-icon name="align-left"></app-icon>
                    </button>
                    <div class="dropdown-menu dropdown-menu-row p-2 rounded-3 gap-1" aria-labelledby="copyAlignDropdown">
                      <a class="dropdown-item w-auto px-3 py-2 rounded-3 cursor-pointer" title="Align left" data-bs-toggle="tooltip" (click)="applyAlign('left')">
                        <app-icon name="align-left"></app-icon>
                      </a>
                      <a class="dropdown-item w-auto px-3 py-2 rounded-3 cursor-pointer" title="Align center" data-bs-toggle="tooltip" (click)="applyAlign('center')">
                        <app-icon name="align-center"></app-icon>
                      </a>
                      <a class="dropdown-item w-auto px-3 py-2 rounded-3 cursor-pointer" title="Align right" data-bs-toggle="tooltip" (click)="applyAlign('right')">
                        <app-icon name="align-right"></app-icon>
                      </a>
                    </div>
                  </div>
                  <button
                    class="btn btn-outline-secondary-2 btn-sm"
                    type="button"
                    title="Horizontal line"
                    data-bs-toggle="tooltip"
                    (click)="insertSeparator()"
                  >
                    <app-icon name="minus"></app-icon>
                  </button>
                  <div class="btn-group">
                    <button
                      class="btn btn-outline-secondary-2 btn-sm dropdown-toggle"
                      type="button"
                      id="copyCalloutDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Callout
                    </button>
                    <div class="dropdown-menu p-2 rounded-3" aria-labelledby="copyCalloutDropdown">
                      <a class="dropdown-item cursor-pointer alert alert-info mb-1 px-3 py-2" (click)="applyCallout('info')">Info</a>
                      <a class="dropdown-item cursor-pointer alert alert-warning mb-1 px-3 py-2" (click)="applyCallout('warning')">Warning</a>
                      <a class="dropdown-item cursor-pointer alert alert-danger mb-0 px-3 py-2" (click)="applyCallout('danger')">Danger</a>
                    </div>
                  </div>
                  <div class="btn-group">
                    <button
                      class="btn btn-outline-secondary-2 btn-sm dropdown-toggle"
                      type="button"
                      id="copyImageDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Image
                    </button>
                    <div class="dropdown-menu p-2 rounded-3" aria-labelledby="copyImageDropdown">
                      <a
                        class="dropdown-item px-3 py-2 rounded-3 cursor-pointer d-flex align-items-center gap-2"
                        title="Float the image at the caret to the left; the text wraps around it"
                        (click)="applyImageWrap('left')"
                      >
                        <app-icon name="wrap-left"></app-icon>
                        Wrap left
                      </a>
                      <a
                        class="dropdown-item px-3 py-2 rounded-3 cursor-pointer d-flex align-items-center gap-2"
                        title="Float the image at the caret to the right; the text wraps around it"
                        (click)="applyImageWrap('right')"
                      >
                        <app-icon name="wrap-right"></app-icon>
                        Wrap right
                      </a>
                    </div>
                  </div>
                </div>
                <textarea
                  #bodyInput
                  #bodyModel="ngModel"
                  class="form-control"
                  style="min-height: 18rem; resize: vertical;"
                  name="bodyHtml"
                  [(ngModel)]="form.bodyHtml"
                  [class.is-invalid]="bodyModel.invalid && bodyModel.touched"
                  rows="12"
                  placeholder="Write the news copy here"
                  required
                ></textarea>
                <div class="invalid-feedback">Body is required</div>
              </div>

              <div class="col-12 col-lg-4">
                <div class="form-floating">
                  <select class="form-select" name="type" [(ngModel)]="form.type" [ngClass]="{ 'select-not-empty': form.type }">
                    <option *ngFor="let newsType of newsTypes" [ngValue]="newsType">{{ newsType | titlecase }}</option>
                  </select>
                  <label class="field-required">Type</label>
                </div>
              </div>

              <div class="col-12 col-lg-4">
                <div class="form-floating">
                  <input class="form-control" name="labels" [(ngModel)]="form.labels" placeholder="Labels" />
                  <label>Labels</label>
                </div>
              </div>

              <div class="col-12 col-lg-4">
                <div class="form-floating">
                  <input
                    class="form-control"
                    name="publicationDate"
                    [(ngModel)]="form.publicationDate"
                    #publicationDateModel="ngModel"
                    [class.is-invalid]="publicationDateModel.invalid && publicationDateModel.touched"
                    type="datetime-local"
                    placeholder="Publication date"
                    required
                  />
                  <label class="field-required">Publication date</label>
                  <div class="invalid-feedback">Publication date is required</div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div class="row g-4 mt-1">
          <div class="col-12">
            <div class="card h-100">
              <div class="card-header border-bottom border-secondary pb-4">
                <h5 class="mb-0">Audience</h5>
              </div>
              <div class="card-body p-4">
                <div class="mt-1">
                  <div *ngIf="customAudienceMissing" class="alert alert-danger py-2">
                    Select at least one recipient or a broadcast group.
                  </div>

                  <div class="border rounded-4 p-3 bg-light mb-3">
                    <div class="small fw-semibold mb-2">Broadcast groups</div>
                    <div class="d-flex flex-wrap gap-4">
                      <div class="form-check mb-0">
                        <input class="form-check-input" id="broadcast-managers" name="allManagers" type="checkbox" [(ngModel)]="form.allManagers" />
                        <label class="form-check-label" for="broadcast-managers">All managers</label>
                      </div>
                      <div class="form-check mb-0">
                        <input class="form-check-input" id="broadcast-students" name="allStudents" type="checkbox" [(ngModel)]="form.allStudents" />
                        <label class="form-check-label" for="broadcast-students">All students</label>
                      </div>
                      <div class="form-check mb-0">
                        <input class="form-check-input" id="broadcast-teachers" name="allTeachers" type="checkbox" [(ngModel)]="form.allTeachers" />
                        <label class="form-check-label" for="broadcast-teachers">All teachers</label>
                      </div>
                    </div>
                  </div>

                  <div class="border rounded-4 p-3 bg-light mb-3">
                    <div class="small fw-semibold">Selected recipients ({{ selectedRecipientItems.length }})</div>
                    <div *ngIf="selectedRecipientItems.length > 0; else noRecipientsSelected" class="d-flex flex-wrap gap-2 mt-2">
                      <button
                        *ngFor="let recipient of selectedRecipientItems"
                        type="button"
                        class="btn btn-outline-secondary-2 rounded-pill text-start d-inline-flex align-items-center gap-2"
                        (click)="removeSelectedRecipient(recipient)"
                      >
                        <span class="badge bg-primary text-uppercase">
                          {{ recipient.type === 'school' ? 'School' : (recipient.personRole | titlecase) }}
                        </span>
                        <span>{{ recipient.label }}</span>
                        <span class="text-muted" *ngIf="recipient.subtitle">({{ recipient.subtitle }})</span>
                        <span class="ms-1">×</span>
                      </button>
                    </div>
                    <ng-template #noRecipientsSelected>
                      <div class="text-muted small mt-2">No recipients selected yet.</div>
                    </ng-template>
                  </div>

                  <ul class="nav nav-pills py-2 mb-3">
                    <li class="nav-item p-0 m-1">
                      <a
                        class="btn rounded-pill btn-sm px-4 py-2"
                        href="#"
                        [ngClass]="{ active: recipientPickerTab === 'schools' }"
                        (click)="$event.preventDefault(); selectRecipientPickerTab('schools')"
                      >
                        Schools
                      </a>
                    </li>
                    <li class="nav-item p-0 m-1">
                      <a
                        class="btn rounded-pill btn-sm px-4 py-2"
                        href="#"
                        [ngClass]="{ active: recipientPickerTab === 'people' }"
                        (click)="$event.preventDefault(); selectRecipientPickerTab('people')"
                      >
                        People
                      </a>
                    </li>
                  </ul>

                  <div *ngIf="recipientPickerTab === 'schools'" class="mb-3">
                    <div class="text-muted small mb-2">
                      Add every manager, student or teacher of a school as an audience.
                    </div>
                    <app-autocomplete [data]="availableSchools">
                      <div class="form-floating mb-2">
                        <input
                          class="form-control"
                          name="schoolSearchTerm"
                          [(ngModel)]="schoolSearchTerm"
                          (ngModelChange)="schoolSearchUpdated()"
                          placeholder="Search schools"
                        />
                        <label>Search schools</label>
                      </div>
                      <ul class="list-group" options>
                        <li
                          *ngFor="let school of availableSchools"
                          class="list-group-item d-flex flex-wrap align-items-center gap-2"
                        >
                          <div class="me-auto">
                            <span class="fw-medium">{{ school.name }}</span>
                            <small class="text-muted d-block" *ngIf="school.country">{{ school.country }}</small>
                          </div>
                          <button
                            *ngFor="let role of schoolAudienceRoles"
                            type="button"
                            class="btn btn-outline-secondary-2 btn-sm rounded-pill"
                            [disabled]="hasSchoolAudience(school, role)"
                            (click)="addSchoolAudience(school, role)"
                          >
                            + {{ getSchoolAudienceLabel(role) }}
                          </button>
                        </li>
                      </ul>
                    </app-autocomplete>
                  </div>

                  <div *ngIf="recipientPickerTab === 'people'">
                    <ul class="nav nav-pills py-2 mb-2">
                      <li class="nav-item p-0 m-1" *ngFor="let role of personRoleFilters">
                        <a
                          class="btn rounded-pill btn-sm px-3 py-1"
                          href="#"
                          [ngClass]="{ active: personPickerRole === role }"
                          (click)="$event.preventDefault(); selectPersonPickerRole(role)"
                        >
                          {{ getPersonRoleLabel(role) }}
                        </a>
                      </li>
                    </ul>

                    <app-autocomplete [data]="availablePeople" (itemSelected)="addPerson($event)">
                      <div class="form-floating mb-2">
                        <input
                          class="form-control"
                          name="personSearchTerm"
                          [(ngModel)]="personSearchTerm"
                          (ngModelChange)="personSearchUpdated()"
                          placeholder="Search people"
                        />
                        <label>Search people by name or email (min. 3 characters)</label>
                      </div>
                      <ul class="list-group" options>
                        <li
                          *ngFor="let person of availablePeople"
                          class="list-group-item cursor-pointer d-flex align-items-center gap-2"
                          (click)="addPerson(person)"
                        >
                          <div class="me-auto">
                            <span class="fw-medium">{{ person.name }} {{ person.surname }}</span>
                            <small class="text-muted d-block" *ngIf="person.email">{{ person.email }}</small>
                            <small class="text-muted d-block" *ngIf="person.schoolName">{{ person.schoolName }}</small>
                          </div>
                          <span class="badge bg-primary text-uppercase">{{ person.role }}</span>
                        </li>
                      </ul>
                    </app-autocomplete>
                    <div class="text-muted small" *ngIf="personSearchPending">Searching…</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="card h-100">
              <div class="card-header border-bottom border-secondary pb-4 d-flex align-items-center justify-content-between gap-2">
                <h5 class="mb-0 me-auto">Main image</h5>
                <button
                  *ngIf="imagePreviewUrl"
                  class="btn btn-outline-secondary-2 btn-sm rounded-pill px-3 py-1"
                  type="button"
                  [disabled]="!canAddGalleryImage"
                  (click)="moveMainImageToGallery()"
                >
                  Move to body images
                </button>
                <button *ngIf="imagePreviewUrl" class="btn btn-danger btn-sm rounded-pill px-3 py-1" type="button" (click)="removeImage()">Remove</button>
              </div>
              <div class="card-body p-4">
                <input #imageInput class="d-none" type="file" accept="image/*" (change)="onImageSelected($event)" />

                <div *ngIf="imagePreviewUrl; else emptyImage" class="ratio ratio-16x9 cursor-pointer" (click)="imageInput.click()">
                  <img [src]="imagePreviewUrl" alt="News preview" class="rounded-1 object-fit-contain" />
                </div>
                <ng-template #emptyImage>
                  <div
                    class="rounded-3 text-muted d-flex align-items-center justify-content-center text-center p-4 bg-light cursor-pointer"
                    style="min-height: 12rem; border: 1px dashed rgba(0, 0, 0, 0.15);"
                    (click)="imageInput.click()"
                  >
                    Click here to upload the main news image.
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="card h-100">
              <div class="card-header border-bottom border-secondary pb-4 d-flex align-items-center justify-content-between">
                <h5 class="mb-0">Body images ({{ galleryImages.length }}/{{ maxGalleryImages }})</h5>
                <button
                  class="btn btn-primary btn-sm rounded-pill px-3 py-1"
                  type="button"
                  [disabled]="!canAddGalleryImage || galleryUploading"
                  (click)="galleryInput.click()"
                >
                  <span *ngIf="galleryUploading" class="me-2 spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  Add images
                </button>
              </div>
              <div class="card-body p-4">
                <input #galleryInput class="d-none" type="file" accept="image/*" multiple (change)="onGalleryImagesSelected($event)" />

                <div *ngIf="galleryImages.length > 0; else emptyGallery" class="list-group">
                  <div
                    *ngFor="let image of galleryImages; let i = index"
                    class="list-group-item d-flex flex-wrap align-items-center gap-3"
                  >
                    <img [src]="image.url" alt="Body image" class="rounded-1 object-fit-cover me-auto" style="width: 6rem; height: 4rem;" />
                    <div class="btn-group" role="group" aria-label="Reorder image">
                      <button class="btn btn-outline-secondary-2 btn-sm" type="button" [disabled]="i === 0" (click)="moveGalleryImage(i, -1)">↑</button>
                      <button class="btn btn-outline-secondary-2 btn-sm" type="button" [disabled]="i === galleryImages.length - 1" (click)="moveGalleryImage(i, 1)">↓</button>
                    </div>
                    <button class="btn btn-outline-secondary-2 btn-sm rounded-pill" type="button" (click)="setAsMainImage(i)">
                      Set as main
                    </button>
                    <button class="btn btn-outline-secondary-2 btn-sm rounded-pill" type="button" (click)="insertGalleryImageIntoBody(image)">
                      Insert into body
                    </button>
                    <button class="btn btn-danger btn-sm rounded-pill" type="button" (click)="removeGalleryImage(i)">Remove</button>
                  </div>
                </div>
                <ng-template #emptyGallery>
                  <div
                    class="rounded-3 text-muted d-flex align-items-center justify-content-center text-center p-4 bg-light cursor-pointer"
                    style="min-height: 8rem; border: 1px dashed rgba(0, 0, 0, 0.15);"
                    (click)="canAddGalleryImage && galleryInput.click()"
                  >
                    Click here to upload up to {{ maxGalleryImages }} images for the news body.
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-header border-bottom border-secondary pb-4">
            <h5 class="mb-0">Preview</h5>
          </div>
          <div class="card-body p-4">
            <div class="mb-2 text-muted small d-flex align-items-center gap-2">
              <span class="badge badge-outline-secondary text-uppercase">{{ form.type }}</span>
              <span>{{ audienceSummary }}</span>
            </div>
            <h3 class="h4 mb-2">{{ form.title || 'News title preview' }}</h3>
            <p class="text-muted" *ngIf="form.subtitle">{{ form.subtitle }}</p>
            <div class="rounded-3 mb-3 overflow-hidden ratio ratio-16x9" *ngIf="imagePreviewUrl">
              <img [src]="imagePreviewUrl" alt="Preview image" class="rounded-1 object-fit-contain" />
            </div>
            <div class="news-copy" [innerHTML]="form.bodyHtml || '<p class=&quot;text-muted&quot;>Body preview</p>'"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-auto ms-auto">
        <button
          class="btn btn-primary rounded-pill px-4 py-2"
          type="button"
          (click)="save()"
          [disabled]="loading"
        >
          <span *ngIf="loading" class="me-2 spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          Save
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal #linkModal>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title">Insert link</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="linkModal.hide()"></button>
    </div>
    <div class="modal-body p-4">
      <form (ngSubmit)="insertLink()">
        <div class="form-floating mb-3">
          <input class="form-control" name="linkUrl" [(ngModel)]="linkUrl" placeholder="Link URL" />
          <label>Link URL</label>
        </div>
        <div class="text-end">
          <button type="button" class="btn btn-secondary rounded-pill px-3 me-2" (click)="linkModal.hide()">Cancel</button>
          <button type="submit" class="btn btn-primary rounded-pill px-3" [disabled]="!linkUrl.trim()">Insert</button>
        </div>
      </form>
    </div>
  </div>
</app-modal>
